/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetKpisEntry } from '../../models/get-kpis-entry';
import { KpiValue } from '../../models/kpi-value';

export interface GetKpis$Params {
  workCenterId: number;
  productionOrderId?: number | null;
  shiftId?: number | null;
      body: GetKpisEntry
}

export function getKpis(http: HttpClient, rootUrl: string, params: GetKpis$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KpiValue>>> {
  const rb = new RequestBuilder(rootUrl, getKpis.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.query('productionOrderId', params.productionOrderId, {});
    rb.query('shiftId', params.shiftId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KpiValue>>;
    })
  );
}

getKpis.PATH = '/api/v1/WorkCenter/{workCenterId}/Kpis';
